import { ActionTree } from "vuex";
import { CommonState, RootState, ApiError, ApplianceList, SearchApplianceList, AttachmentList, PantryCameraImageResult } from "@/types/common";
import NativeClient from "@/client/native-client";

const actions: ActionTree<CommonState, RootState> = {
  startLoading: async ({ commit }) => {
    commit("startLoading", true);
  },
  stopLoading: async ({ commit }) => {
    commit("stopLoading", false);
  },
  updateToken: async ({ commit }, token: string) => {
    commit("updateToken", token);
  },
  updateApiKey: async ({ commit }, apiKey: string) => {
    commit("updateApiKey", apiKey);
  },
  updateApplianceId: async ({ commit }, applianceId: string) => {
    commit("updateApplianceId", applianceId);
  },
  updateAppliance: async ({ commit }, appliance: string) => {
    commit("updateAppliance", appliance);
  },
  // 以下は、非同期処理のため削除
  // getApiBaseParams: async () => {
  //   NativeClient.getToken();
  //   NativeClient.getApplianceId();
  //   NativeClient.getApiKey();
  //   NativeClient.getAppliance();
  //   NativeClient.getApplianceList();
  // },
  updatedApiError: async ({ commit }, apiError: ApiError | null) => {
    commit("updateApiError", apiError);
  },
  updateLogId: async ({ commit }, logId: string | null) => {
    commit("updateLogId", logId);
  },
  updateApplianceList: async ({ commit }, appliances: ApplianceList | null) => {
    commit("updateApplianceList", appliances);
  },
  updateSearchAppliance: async ({ commit }, appliances: string | null) => {
    commit("updateSearchAppliance", appliances);
  },
  updateUserAgent: async ({ commit }, userAgent: string | null) => {
    commit("updateUserAgent", userAgent);
  },
  updateAttachmentList: async ({ commit }, attchmentList: AttachmentList | null) => {
    commit("updateAttachmentList", attchmentList);
  },
  startFullscreenLoading: async ({ commit }) => {
    NativeClient.requestDisplayLoading(true);
    commit("updateFullscreenLoading", true);
  },
  stopFullscreenLoading: async ({ commit }) => {
    NativeClient.requestDisplayLoading(false);
    commit("updateFullscreenLoading", false);
  },
  updatePantryCameraImage: async ({ commit }, pantryCameraImage: PantryCameraImageResult | null) => {
    commit("updatePantryCameraImage", pantryCameraImage);
  },
};

export default actions;
